import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex max-w-200 flex-col-reverse gap-4 max-lg:-mx-3 lg:flex-row lg:gap-2 lg:gap-10 lg:px-7',
    imageWrapper: 'bg-accent flex h-full w-full shrink-0 grow-0 items-center',
    image: 'aspect-square w-full object-contain',
    arrow: 'border-0',
    viewport: 'relative overflow-hidden',
    container: 'flex h-full items-center',
    tags: 'absolute top-0 left-0 z-10 flex gap-[2px] lg:right-7 lg:left-auto',
    productOverlay: 'product-overlay',
    thumbs: 'flex items-center justify-center gap-5 lg:flex-col',
    thumbsViewport:
      'w-[calc(100vw-32px)] overflow-hidden lg:max-h-133 lg:w-auto',
    thumbsContainer: 'flex items-center gap-2 lg:h-full lg:flex-col lg:gap-5',
    thumbArrow:
      'text-main z-10 hidden h-6 border-0 p-0 hover:bg-inherit lg:block',
    thumbArrowIcon: 'hover:[&>path]:stroke-icon-brand h-5 w-3'
  },
  variants: {
    hide: {
      true: {
        arrow: 'opacity-0',
        thumbArrow: 'opacity-0',
        thumbs: 'relative -z-1 opacity-0'
      }
    }
  }
});
